import { IOfferCard } from '../../../../types';

export const prepareName = ({ offerUser, isByHomeowner }: IOfferCard): string => {
  const { masterAgent, cianUserId, agencyName } = offerUser || {};

  if (isByHomeowner) {
    return cianUserId ? `ID ${cianUserId}` : '';
  }

  if (masterAgent && masterAgent.name) {
    return masterAgent.name;
  }

  if (agencyName) {
    return agencyName;
  }

  if (cianUserId) {
    return `ID ${cianUserId}`;
  }

  return '';
};
